import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesRoutingModule } from './pages-routing.module';
import { PagesComponent } from './pages.component';
import { SourcingDiscoveryComponent } from './sourcing-discovery/sourcing-discovery.component';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '../material-module';
import { HeaderComponent } from '../shared/header/header.component';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { CountryselectionComponent } from './countryselection/countryselection.component';
import { AuthGuardService } from './auth.guard';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { ProductHeaderComponent } from '../shared/product-header/product-header.component';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { ProductSourcingDetailComponent } from './product-sourcing-detail/product-sourcing-detail.component';
import { ProductViewComponent } from './product-view/product-view.component';
import { NoResultFoundComponent } from './no-result-found/no-result-found.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import {SupplierDetailComponent} from  './supplier-detail/supplier-detail.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { NoDataFoundComponent } from './no-data-found/no-data-found.component';
import { ProductVarientComponent } from './product-varient/product-varient.component';
import { RouterModule } from '@angular/router';
import {MatCardModule} from '@angular/material/card';
import {MatExpansionModule} from '@angular/material/expansion';
import { CompanyPrductGroupComponent } from './company-prduct-group/company-prduct-group.component';
import { MatTooltipModule } from '@angular/material/tooltip';

@NgModule({
  declarations: [
    CountryselectionComponent,
    PagesComponent, 
    HeaderComponent, ProductHeaderComponent,
    SourcingDiscoveryComponent, 
    ProductSourcingDetailComponent,
    ProductViewComponent,
    NoResultFoundComponent,SupplierDetailComponent, ProductDetailComponent, ProductVarientComponent,CompanyPrductGroupComponent
   
    
    ], // Add SourcingDiscoveryComponent to declarations
  imports: [CommonModule, InfiniteScrollModule,
    MatSelectModule,
    MatInputModule,MatMenuModule,MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    RouterModule,
    MatCardModule,
    MatExpansionModule,
    PagesRoutingModule,HttpClientModule,MaterialModule, Ng2SearchPipeModule, MatTooltipModule ],
    providers: [AuthGuardService]
})
export class PagesModule {}
